export default "__VITE_ASSET__9870e9ba__"